import { Injectable, inject } from '@angular/core';
import { CanActivate, UrlTree, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { LocalRoutes } from '../local-routes';
import { AppSettingService } from '../app-setting.service';
import { ErrorPageNavigationService } from '../components/error-pages/error-page-navigation.service';

@Injectable({
	providedIn: 'root',
})
export class SigninGuard implements CanActivate {
	authService = inject(AuthService);
	private router = inject(Router);
	private appSettingService = inject(AppSettingService);
	private errorPageNavigationService = inject(ErrorPageNavigationService);


	constructor() {}

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		return new Promise((res) => {
			if (!this.appSettingService.appSetting.enableSsoAutoRedirect) {
				return res(true);
			}

			this.authService.isExternalAuth().subscribe(
				(result) => {
					if (result) {
						this.router.navigate(['/sso']);
						return res(false);
					} else {
						return res(true);
					}
				},
				(error) => {
					console.error(error);

					this.errorPageNavigationService.showErrorPage(LocalRoutes.SERVER_ERROR, state.url);
					return res(false);
				}
			);
		});
	}
}
